import 'ol/ol.css';
import 'bootstrap';
import $ from 'jquery';
import { Map, View, Overlay, Geolocation } from 'ol';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import VectorSource from 'ol/source/Vector';
import OSM from 'ol/source/OSM';
import { toStringHDMS } from 'ol/coordinate';
import { fromLonLat, toLonLat } from 'ol/proj';
import { Icon, Style, Circle as CircleStyle, Fill, Stroke } from 'ol/style';

export default class MapService {
	constructor(containerSelector, data, fixedMode) {
		this.container = document.querySelector(containerSelector);
		this.data = data;
		this.initialized = false;
		this.fixedMode = fixedMode;
		this.DEFAULT_COORDS = [7.135713, 51.593901];
		//this.DEFAULT_COORDS = [9.5849223, 52.27797];
		this.DEFAULT_ZOOM = 14;
	}

	initMap() {
		var view = new View({
			center: fromLonLat(this.DEFAULT_COORDS),
			zoom: this.DEFAULT_ZOOM,
		});

		const positionFeature = this.buildOwnPositionFeature();

		document.getElementById('map').innerHTML = '';

		let mapOptions = {
			target: this.container,
			layers: [
				new TileLayer({
					className: 'filtered-layer',
					source: new OSM(),
				}),
			],
			view: view,
		};

		var geolocation = new Geolocation({
			// enableHighAccuracy must be set to true to have the heading value.
			trackingOptions: {
				enableHighAccuracy: true,
			},
			projection: view.getProjection(),
		});
		geolocation.setTracking(true);

		if (this.fixedMode) {
			mapOptions.controls = [];
		}

		geolocation.on('change:position', function () {
			var coordinates = geolocation.getPosition();
			positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
		});

		geolocation.on('error', function (error) {
			console.log('error getting positon', error);
		});

		const map = new Map(mapOptions);

		let features = this.getFeatures(positionFeature);
		features.push(positionFeature);
		new VectorLayer({
			map: map,
			source: new VectorSource({
				features: features,
			}),
		});

		var popup = new Overlay({
			element: document.getElementById('popup'),
		});

		map.addOverlay(popup);

		if (!this.fixedMode) {
			map.on('click', function (evt) {
				var feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
					return feature;
				});
				var element = popup.getElement();

				$(element).popover('dispose');
				if (feature) {
					const featureProps = feature.get('props');
					if (featureProps) {
						var coordinate = evt.coordinate;
						var hdms = toStringHDMS(toLonLat(coordinate));
						console.log([featureProps.longitude, featureProps.latitude], coordinate, hdms);

						popup.setPosition(fromLonLat([featureProps.longitude, featureProps.latitude]));
						$(element).popover({
							container: element,
							placement: 'top',
							animation: false,
							html: true,
							content: `<h6>${featureProps.title}</h6><p class="mb-0"><a href="/spur.html#${featureProps.id}" class="btn btn-primary btn-sm">Spur&nbsp;ansehen</a></p>`,
						});
						$(element).popover('show');
					}
				}
			});
		}

		setTimeout(function () {
			map.updateSize();
		}, 20);

		this.MAP = map;
	}

	getFeatures() {
		let features = [];

		if (this.data) {
			this.data.forEach((item) => {
				features.push(this.buildFeature(item));
			});
		}
		return features;
	}

	center(coordsArray) {
		this.MAP.getView().setCenter(fromLonLat(coordsArray));
	}

	buildFeature(item) {
		var svg =
			'<svg width="1em" height="1em" fill="currentColor" class="bi bi-geo-alt-fill text-primary" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
			'<path fill-rule="evenodd" d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>' +
			'</svg>';

		var iconStyle = new Style({
			image: new Icon({
				anchor: [0.5, 15],
				anchorXUnits: 'fraction',
				anchorYUnits: 'pixels',
				opacity: 1,
				src: 'data:image/svg+xml;utf8,' + svg,
				scale: 2,
			}),
		});

		var iconFeature = new Feature({
			geometry: new Point(fromLonLat([item.longitude, item.latitude])),
			props: item,
		});

		iconFeature.setStyle(iconStyle);

		return iconFeature;
	}

	buildOwnPositionFeature() {
		var positionFeature = new Feature();

		positionFeature.setStyle(
			new Style({
				image: new CircleStyle({
					radius: 6,
					fill: new Fill({
						color: '#3399CC',
					}),
					stroke: new Stroke({
						color: '#fff',
						width: 2,
					}),
				}),
			})
		);
		return positionFeature;
	}
}
